import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react'
import { useValue } from '../../context/ContextProvider';
import { useNavigate } from 'react-router-dom';
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, IconButton, InputLabel, MenuItem, Select, Stack, Tab, Tabs, TextField, Typography } from '@mui/material';
import { getProductos } from '../../actions/productos';

import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send'
import SaveIcon from '@mui/icons-material/Save';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField, LocalizationProvider, TimeField } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import "dayjs/locale/es";
import { DataGrid } from '@mui/x-data-grid';
import AlmacenTabla from './almacenIngresar/AlmacenTabla';
import AlmacenTabla2 from './almacenIngresar/AlmacenTabla2';
import AlmacenTabla3 from './almacenIngresar/AlmacenTabla3';
import AlmacenIngresar from './almacenIngresar/AlmacenIngresar';
import { getLastRowsAlmacen } from '../../actions/almacen';
import AlmacenTablaMover from './almacenMover/AlmacenTablaMover';
import AlmacenMover from './almacenMover/AlmacenMover';
import { getProveedores } from '../../actions/proveedores';
import AlmacenGestionar from './almacenGestionar/AlmacenGestionar';

//==================================================================================================== 
// Manejo de los tabse gestión (Ingresar, Retirar, Mover)
//==================================================================================================== 
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    //console.log({value});

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <>{children}</>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
//====================================================================================================



const Almacen = () => {


    /* To Do: Cambiar este modelo de permisos por uno que controle el servidor */
    const permisos = ['superusuario', 'administrador'];
    const navigate = useNavigate();
    const [visibilidad, setVisibilidad] = useState(false);
    const { state: { contextLoading, currentUser, productos, proveedores }, dispatch } = useValue();
    const [productosOptions, setProductosOptions] = useState([]);
    const [proveedoresOptions, setProveedoresOptions] = useState([]);
    const [preciosEnAlmacen, setPreciosEnAlmacen] = useState([]);   //Guarda los precios que se recuperan del almacen del ultimo registro ingresado de cada producto
    const [disponibilidadProducto, setDisponibilidadProducto] = useState([]);

    const [filas, setFilas] = useState([])

    useEffect(() => {
        //Renderiza la pagina al principio y cuando contextLoading cambia a falso. 
        //Código para hecho para refresh, cambio de páginas y autorizaciones.
        //console.log('ejecutando useEffect');
        //console.log({ contextLoading });
        if (contextLoading === false) {
            //console.log('Context loaded');
            if (!permisos.includes(currentUser?.tipoUsuario)) {
                dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: 'Página no autorizada! Redirecionando a Inicio.' } });
                navigate('/');
            } else {
                if (productos?.length == 0) {
                    //console.log('Solicitando Productos al servidor.');
                    getProductos(currentUser, dispatch);
                    getLastRowsAlmacen(currentUser, dispatch, setPreciosEnAlmacen);
                } else {
                    if (productos?.length > 0) {
                        const prodOpt = productos.map((producto) => (
                            { id: producto.id, label: producto.product }
                        ));
                        setProductosOptions(prodOpt);
                        //console.log({ productos, productosOptions });
                    } else {
                        //console.log('No products yet')
                    }
                }
                if (proveedores?.length == 0) {
                    //console.log('Solicitando Proveedores al servidor.');
                    getProveedores('todo', currentUser, dispatch);
                } else {
                    if (proveedores?.length > 0) {
                        const provOpt = proveedores.map((p) => (
                            { id: p.id, label: p.proveedor }
                        ));
                        setProveedoresOptions(provOpt);
                        //console.log({ productos, productosOptions });
                    } else {
                        //console.log('No products yet')
                    }
                }


                setVisibilidad(true);
            }
        } else {
            //console.log('Context not loaded');
        }

    }, [contextLoading, currentUser, productos, proveedores]);






    //---------------------------------------------------------------------------
    // Variables/funciones para la gestión de los tabs
    //---------------------------------------------------------------------------
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    //---------------------------------------------------------------------------




    return (
        <>
            {visibilidad ?
                <Stack
                    direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
                    spacing={0}
                    justifyContent={{ lg: 'center' }}
                    flexGrow={1} pt={2} pb={2}
                >
                    <Box hidden={value == 0 ? false : true} bgcolor='white' borderRight={1} borderColor='lightgray' flex={8} marginRight={0} padding={1} paddingRight={2} style={{ width: '100%', borderRadius: 0, alignItems: 'center' }} >
                        <AlmacenTabla3
                            currentUser={currentUser}
                            dispatch={dispatch}
                            filas={filas}
                            setFilas={setFilas}
                        />
                    </Box>

                    <Box hidden={value == 1 ? false : true} bgcolor='white' borderRight={1} borderColor='lightgray' flex={8} marginRight={0} padding={1} paddingRight={2} style={{ width: '100%', borderRadius: 0, alignItems: 'center' }} >
                        <AlmacenTablaMover
                            currentUser={currentUser}
                            dispatch={dispatch}
                            disponibilidadProducto = {disponibilidadProducto}
                            setDisponibilidadProducto = {setDisponibilidadProducto}
                        />
                    </Box>

                    <Box hidden={value == 2 ? false : true} bgcolor='lightblue' borderRight={1} borderColor='lightgray' flex={8} marginRight={0} padding={1} paddingRight={2} style={{ width: '100%', borderRadius: 0, alignItems: 'center' }} >
                        <AlmacenGestionar />
                    </Box>



                    <Box bgcolor='white' flex={4} padding={1} paddingLeft={2} style={{ borderRadius: 0, width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs variant="fullWidth" value={value} onChange={handleChange} aria-label="almacen tabs">
                                <Tab label="Ingresar" {...a11yProps(0)} />
                                <Tab label="Mover" {...a11yProps(1)} />
                                <Tab label="Gestionar" {...a11yProps(2)} />
                            </Tabs>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                            <AlmacenIngresar
                                productosOptions={productosOptions}
                                proveedoresOptions={proveedoresOptions}
                                filas={filas}
                                setFilas={setFilas}
                                preciosEnAlmacen={preciosEnAlmacen}
                            />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <AlmacenMover
                                currentUser={currentUser}
                                dispatch={dispatch}
                                productosOptions={productosOptions}
                                setDisponibilidadProducto={setDisponibilidadProducto}
                            />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={2}>
                            Gestionar Almacen
                        </CustomTabPanel>
                    </Box>
                </Stack>
                :
                <div>Página no autorizada.</div>
            }

        </>
    )
}

export default Almacen